export default "__VITE_ASSET__CMI_ubJQ__"